import React from 'react'

export const Alert = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_6012)'>
      <path
        d='M12.866 2.99996L22.392 19.5C22.4798 19.652 22.526 19.8244 22.526 20C22.526 20.1755 22.4798 20.3479 22.392 20.4999C22.3042 20.652 22.178 20.7782 22.026 20.866C21.874 20.9537 21.7015 21 21.526 21H2.474C2.29847 21 2.12603 20.9537 1.97401 20.866C1.822 20.7782 1.69576 20.652 1.608 20.4999C1.52023 20.3479 1.47403 20.1755 1.47403 20C1.47403 19.8244 1.52024 19.652 1.608 19.5L11.134 2.99996C11.2218 2.84795 11.348 2.72172 11.5 2.63396C11.652 2.5462 11.8245 2.5 12 2.5C12.1755 2.5 12.348 2.5462 12.5 2.63396C12.652 2.72172 12.7782 2.84795 12.866 2.99996ZM11 16V18H13V16H11ZM11 8.99996V14H13V8.99996H11Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_6012'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
